"use client";
import "./bottomGard.css";
import Image from "next/image";
import CustomButton from "src/components/atoms/CustomButton";

const TychoBottomGrad = () => {
  return (
    <div className="bottom-grad-section">
      <div className="bottom-grad-banner ">
        <Image src="/images/whyUsTB.webp" alt="Team banner" fill className="object-cover lg:object-contain dark:hidden" priority />
        <Image src="/images/whyUsT.webp" alt="Team banner" fill className="object-cover lg:object-contain hidden dark:block" priority />

        <div className="banner-overlay" />

        <div className="banner-content">
          <div className="content-wrapper">
            <div className="banner-text">
              <h3 className="banner-title">Come build with us</h3>
              <p className="banner-text-body">
                Your next chapter might just start here.
                <br />
                We're always looking for sharp, kind humans. Designers, engineers, storytellers — if any of this felt like home, write to us.
              </p>
              <div className="   flex justify-center items-center md:items-start md:justify-start">
                <CustomButton title="See Open Roles" href="/career#recent-openings" style={{ height: "42px" }} className="px-1!" />
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
              <Image src="/images/Tycho_Logo_new.png" alt="Tycho Technologies" width={70} height={10} style={{ objectFit: "contain" }} priority />
              <h3 className="font-display text-2xl md:text-3xl leading-[1.20] text-text-primary flex flex-col tracking-widest tracking-[4px]">
                TYCHO
                <span className="bg-gradient-to-r from-[var(--c-brand)] to-[var(--c-accent)] bg-clip-text text-transparent text-[11px] md:text-[14px] tracking-[3px]">
                  Technologies
                </span>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TychoBottomGrad;
